
import styles from "../../../../AccountingPage.module.scss";
import { useEffect, useState } from 'react'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getStudentsContractData, postContractData, getContractAmountsData, getCoursesData, getStudentsDetailData } from "service/AccountingService";
import Notification from "utils/Notifications";

const StudentContractPayContent = ({ render, setRender, id }) => {
  const componentRef = useRef();
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [datahistory, setDataHistory] = useState([]);
  const getDataHistory = async (id) => {
    try {
      let response = await getStudentsContractData(id, datahistory);
      setDataHistory(response.data);
    } catch (error) {
      console.log("onoxo")
    }
  };
  const [contractamounts, setContractAmounts] = useState([]);
  const getContractAmounts = async (departmentId, yearId, typeId) => {
    try {
      const response = await getContractAmountsData(yearId, departmentId, typeId);
      setContractAmounts(response.data);

    } catch (error) {
      console.log("Ошибка при получении сумм контрактов:", error);
    }
  };
  const [courses, setCourses] = useState([]);
  const getCourses = async (id) => {
    try {
      let response = await getCoursesData(id, courses);
      setCourses(response.data);

    } catch (error) {
      console.log("onoxo")
    }
  };
  const [datastudent, setData] = useState([]);
  const getData = async (id) => {
    try {
      let response = await getStudentsDetailData(id, datastudent);
      setData(response.data);
      if (response.data.academic_year && response.data.departmentID && response.data.educationtype) {
        getDataHistory(id);
        getCourses(response.data.fund)
        getContractAmounts(response.data.departmentID, response.data.academic_year, response.data.educationtype);
      }

    } catch (error) {
      console.log("onoxo")
    }
  };
  useEffect(() => {
    getData(id)
    setRender(false);
  }, [render]);


  const [editCourseId, setEditCourseId] = useState(null);
  const [editedBenefit, setEditedBenefit] = useState("");

  const onSave = async (id) => {
    const formData = new FormData();
    formData.append("course", editCourseId);
    formData.append("benefits", editedBenefit);

    const response = await postContractData(datastudent.id, formData); // твой API


    setNotify({
      isOpen: true,
      message: "Льгота успешно обновлён!",
      type: "success",
      sound: "success"
    });
    setRender(true);
    setEditedBenefit(null);
    setEditCourseId(null);

  };


  return (
    <>

      <div className={styles.content_header} style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ width: "100%" }} className={styles.print_header_selection_shah}>
          <table className={styles.table__wrapper}>
            <thead className={styles.table__head}>
              <tr className={styles.table__row}>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>ИНН</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Фамилия</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Имя</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Специальность</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Вид обучения</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>Дата и время</span>
                </th>
              </tr>
            </thead>
            <tbody className={styles.table__body}>
              <tr className={styles.table__row}>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.inn}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.surname}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.first_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.speciality_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.educationtype_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>
                    {new Date().toLocaleString("ru-RU", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className={styles.project__h}>Контракт</h3>
          <hr style={{ borderTop: '2px solid #444', margin: '20px 0 0 0' }} />
        </div>



        <table ref={componentRef} className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>



              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>Курс</span>
              </th>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>Контракт</span>
              </th>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>Льгота(%)</span>
              </th>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>Сумма</span>
              </th>
              {datastudent.status !== "Выпущен(а)" && (
                <th className={styles.table__item__nav} >
                  <span className={styles.table__title}>Действия</span>
                </th>
              )}
            </tr>
          </thead>

          <tbody className={styles.table__body}>
            {courses.map((itemcourse) => {
              const contractMatch = contractamounts.find(
                (contract) =>
                  contract.speciality === datastudent.speciality &&
                  contract.course === itemcourse.id
              );

              const benefitMatch = datahistory.find(
                (history) => history.course === itemcourse.id
              );

              return (
                <tr className={styles.table__row} key={itemcourse.id}>
                  <td className={styles.table__item_contract}>
                    <span className={styles.table__title}>
                      {itemcourse.name} курс
                    </span>
                  </td>

                  <td className={styles.table__item_contract}>
                    <span className={styles.table__title}>
                      {contractMatch ? contractMatch.amount : "не указан"}
                    </span>
                  </td>

                  <td className={styles.table__item_contract}>
                    {editCourseId === itemcourse.id ? (
                      <input
                        className={styles.edit_input}
                        type="number"
                        value={editedBenefit}
                        onChange={(e) => setEditedBenefit(e.target.value)}
                        placeholder="Введите льготу"
                      />
                    ) : (
                      <span className={styles.table__title}>
                        {benefitMatch ? benefitMatch.benefits : "не указано"}
                      </span>
                    )}
                  </td>
                  <td className={styles.table__item_contract}>
                    <span className={styles.table__title}>
                      {contractMatch && (benefitMatch?.benefits || benefitMatch?.benefits === "0") ? (
                        (() => {
                          const amount = parseFloat(contractMatch.amount);
                          const percent = parseFloat(benefitMatch.benefits.replace("%", "").replace(",", "."));
                          const discounted = amount - (amount * percent / 100);
                          return discounted.toFixed(2);
                        })()
                      ) : (
                        "не указано"
                      )}
                    </span>
                  </td>
                  {datastudent.status !== "Выпущен(а)" && (
                    <td className={styles.table__item_contract}>
                      <div className={styles.table__item__div}>
                        {editCourseId === itemcourse.id ? (
                          <>
                            <button
                              onClick={() => onSave(itemcourse.id)}
                              className={styles.saveBtn}
                            >
                              💾
                            </button>
                            <button
                              onClick={() => setEditCourseId(null)}
                              className={styles.cancelBtn}
                            >
                              ❌
                            </button>
                          </>
                        ) : (
                          <button
                            onClick={() => {
                              setEditCourseId(itemcourse.id);
                              setEditedBenefit(benefitMatch?.benefits || "");
                            }}
                            className={styles.editBtn}
                          >
                            ✏️
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>





        </table>

      </div>

      <Notification notify={notify} setNotify={setNotify} />
    </>


  );
};

export default StudentContractPayContent;
